<template>
  <div class="container">
    <div class="wrapper" v-if="!loading">
      <div class="content">
        <div class="content__left">
          <TheHeader/>
          <TheInner/>
          <div class="desktop-footer">
            <TheFooter/>
          </div>
        </div>
        <div class="content__right">
          <VideoSection/>
        </div>
      </div>
      <div class="mobile-footer">
        <TheFooter/>
      </div>
    </div>
    <Loader v-if="loading"/>
  </div>
</template>
<script>

import TheHeader from "@/layout/Home/TheHeader";
import TheInner from "@/layout/Home/TheInner";
import TheFooter from "@/layout/Home/TheFooter";
import VideoSection from "@/layout/Home/VideoSection";
import Loader from "@/components/Loader";

export default {
  components: {TheFooter, TheHeader, TheInner, VideoSection, Loader},
  data(){
    return {
      loading: true,
    }
  },
  created() {
    window.addEventListener("load", ()=> {
      this.loading = false;
    });
  }
}
</script>
